import { c as _c } from "react/compiler-runtime";
import { useTheme } from 'styled-components';
import { CodeBlock } from '../../DashboardScene/Event/CodeBlock';
import Button from '../../../common/base/Button';
import Divider from '../../../common/base/Divider';
import Text from '../../../common/base/Text';
import Link from '../../../common/base/Link';
import { Div } from '../../../common/helpers/StyledUtils';
import { CollapsableDataSection } from '../../../common/Data/CollapsableDataSection';
import useLocalStorage from '../../../hooks/useLocalStorage';
import { ContextMenuConfig } from '../../../common/JSONBrowser';

/**
 * Collapsible section for Outpost event payload/data. Uses the same UI pattern as
 * BodyCollapsibleSection but does not pass event-gateway-specific props (type, id,
 * or default context_menu_config) to CodeBlock.
 */
export const OutpostDataCollapsibleSection: React.FC<{
  data: object;
  embedded: boolean;
  collapsible?: boolean;
  default_collapsed?: boolean;
  collapsed_storage_key?: string;
  context_menu?: boolean;
  context_menu_config?: ContextMenuConfig | null;
}> = t0 => {
  const $ = _c(45);
  const {
    data,
    embedded,
    collapsible: t1,
    default_collapsed: t2,
    collapsed_storage_key: t3,
    context_menu: t4,
    context_menu_config: t5
  } = t0;
  const collapsible = t1 === undefined ? true : t1;
  const default_collapsed = t2 === undefined ? false : t2;
  const collapsed_storage_key = t3 === undefined ? "prefs:outpost:data:collapsed" : t3;
  const context_menu = t4 === undefined ? false : t4;
  const context_menu_config = t5 === undefined ? null : t5;
  const [collapsed_state, setCollapsed] = useLocalStorage(collapsed_storage_key, default_collapsed);
  const collapsed = collapsible ? collapsed_state : false;
  const theme = useTheme();
  const t6 = embedded ? 100 : undefined;
  let t7;
  if ($[0] !== embedded) {
    t7 = embedded ? {
      x: 6
    } : undefined;
    $[0] = embedded;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const t8 = embedded ? 0 : 8;
  let t9;
  if ($[2] !== t8) {
    t9 = {
      b: t8
    };
    $[2] = t8;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  const t10 = embedded && !collapsed ? theme.colors.surface.base.variant_surface_3 : undefined;
  let t11;
  if ($[4] !== t10) {
    t11 = {
      backgroundColor: t10
    };
    $[4] = t10;
    $[5] = t11;
  } else {
    t11 = $[5];
  }
  let t12;
  if ($[6] !== collapsed || $[7] !== setCollapsed) {
    t12 = <Text semi={true} onClick={() => setCollapsed(!collapsed)}>Data</Text>;
    $[6] = collapsed;
    $[7] = setCollapsed;
    $[8] = t12;
  } else {
    t12 = $[8];
  }
  let t13;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      align: "center",
      gap: 2
    };
    $[9] = t13;
  } else {
    t13 = $[9];
  }
  let t14;
  if ($[10] !== collapsed || $[11] !== embedded) {
    t14 = embedded && !collapsed && <><CodeBlock.DropdownDisplayType ghost={true} /><CodeBlock.ButtonCopy ghost={true} /></>;
    $[10] = collapsed;
    $[11] = embedded;
    $[12] = t14;
  } else {
    t14 = $[12];
  }
  let t15;
  if ($[13] !== collapsed || $[14] !== collapsible || $[15] !== embedded || $[16] !== setCollapsed) {
    t15 = collapsible && (embedded ? <Button ghost={true} icon={collapsed ? "chevron_down" : "chevron_up"} onClick={() => setCollapsed(!collapsed)} /> : <Link neutral={true} icon={collapsed ? "chevron_down" : "chevron_up"} onClick={() => setCollapsed(!collapsed)} />);
    $[13] = collapsed;
    $[14] = collapsible;
    $[15] = embedded;
    $[16] = setCollapsed;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== t14 || $[19] !== t15) {
    t16 = <Div flex={t13}>{t14}{t15}</Div>;
    $[18] = t14;
    $[19] = t15;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== collapsed || $[22] !== embedded || $[23] !== t12 || $[24] !== t16) {
    t17 = <CollapsableDataSection embedded={embedded} collapsed={collapsed} z_index={1}>{t12}{t16}</CollapsableDataSection>;
    $[21] = collapsed;
    $[22] = embedded;
    $[23] = t12;
    $[24] = t16;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== collapsed || $[27] !== embedded) {
    t18 = !collapsed && <Div flex={{
      direction: "column",
      gap: embedded ? 0 : 4
    }}><Div flex={{
        gap: 3
      }} m={embedded ? {
        x: 6
      } : undefined}><CodeBlock.Search m={embedded ? {
          b: 4
        } : undefined} />{!embedded && <><CodeBlock.DropdownDisplayType /><CodeBlock.ButtonCopy /></>}</Div><CodeBlock.Code /></Div>;
    $[26] = collapsed;
    $[27] = embedded;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== embedded) {
    t19 = embedded && <Divider />;
    $[29] = embedded;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t11 || $[32] !== t17 || $[33] !== t18 || $[34] !== t19 || $[35] !== t9) {
    t20 = <Div m={t9} style={t11}>{t17}{t18}{t19}</Div>;
    $[31] = t11;
    $[32] = t17;
    $[33] = t18;
    $[34] = t19;
    $[35] = t9;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== context_menu || $[38] !== context_menu_config || $[39] !== data || $[40] !== embedded || $[41] !== t20 || $[42] !== t6 || $[43] !== t7) {
    t21 = <CodeBlock.Provider text={data} embedded={embedded} filters_width={t6} filters_margin={t7} context_menu={context_menu} context_menu_config={context_menu_config}>{t20}</CodeBlock.Provider>;
    $[37] = context_menu;
    $[38] = context_menu_config;
    $[39] = data;
    $[40] = embedded;
    $[41] = t20;
    $[42] = t6;
    $[43] = t7;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  return t21;
};